module.exports = __webpack_public_path__ + "img/fantasyji.7e578357.webp";